import { render, staticRenderFns } from "./platform-page.vue?vue&type=template&id=397fdc75"
import script from "./platform-page.vue?vue&type=script&lang=js"
export * from "./platform-page.vue?vue&type=script&lang=js"
import style0 from "./platform-page.vue?vue&type=style&index=0&id=397fdc75&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports